import { combineReducers } from "redux";
import radio from "./radio";

export default combineReducers({
  radio
});
